module.exports = __webpack_public_path__ + "static/img/kj.11313b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/medicine/kj.png
// module id = R6R3
// module chunks = 1